/* global process */
import axios from 'axios';
import { AuthService } from '@/services';

const baseURL = process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_FROM_1099_URL : `${window.location.origin}/`;

const taxAPI = axios.create({
  baseURL,
});

taxAPI.defaults.headers['x-api-key'] = process.env.VUE_APP_TOKEN_API_KEY;
taxAPI.defaults.headers['x-client-version'] = process.env.VUE_APP_CLIENT_VERSION;
taxAPI.defaults.headers['Accept'] = 'application/pdf, application/json, text/plain, */*';

taxAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      AuthService.signOutUser();
    }

    return Promise.reject(error);
  },
);

export default taxAPI;
